import i18next from 'i18next';

i18next.addResources('es', 'DocumentaryEvidence', {
  detail: 'Detalle',
  part: 'Parte',
  searchBarPlaceholder: 'Detalle'
});
